export default class BeneficiarioNoAfiliado {
    constructor(
        public cedulaBeneficiario?: string,
        public password?: string,
        public primerNombre?: string,
        public segundoNombre?: string,
        public primerApellido?: string,
        public segundoApellido?: string,
        public correoElectronico1?: string,
        public correoElectronico2?: string,
        public celular?: string,
        public telefonoResidencia?: string,
        public otroTelefono?: string,
        public domicilio?: string,
        public numero?: string,
        public edificio?: string,
        public apartamento?: string,
        public codSector?: string,
        public codCiudad?: string,
        public viaRegistro?: string,
        public viaNotificacion?: string,
        public contrasena?: string
    ) {}
}